// VRF CUSTOM: Contact links in product copy open the product inquiry modal.
// Any link to the contact page inside the PDP's product copy (description,
// feature blocks, short description) opens the "Need help deciding?" modal,
// whether or not it carries data-offer-support-link. That attribute gets
// stripped when a description is re-saved in Shopify's editor, and older copy
// links to https://valleyridge.ca/pages/contact in a new tab.
//
// - One delegated listener on document, so links inside regions the variant
//   picker re-renders keep working after a variant change.
// - The href is left alone: without JS, or with a modifier/middle click, the
//   link still goes to the contact page.
// - Opens the modal through the hidden #oos-popup-button, like the other
//   inquiry triggers, so the Globo form lazy-loads and the variant is filled
//   in. Focus moves into the dialog and returns to the clicked link when
//   the modal closes.
// - Skips clicks another handler already took (defaultPrevented), e.g. the
//   per-link handler in snippets/offer-support-links.liquid.
// Loaded by snippets/vrf-product-inquiry-popup.liquid, so it is only on pages
// that have the modal.

(function () {
  if (window.VrfProductCopyContactLinks) return;

  // Product copy containers on the PDP. Collapsible-content blocks are left
  // out on purpose: they have their own per-block "enable_oos_popup_links"
  // setting (vrf-product-inquiry-link-trigger.js).
  var COPY_SELECTOR = '.product-description, .feature-blocks, .product-info__block.rte';

  // Another product's copy can be on the page (quick-add drawer, compare
  // drawer); the modal is for the product this page is about.
  var EXCLUDE_SELECTOR = '.js-quickbuy, .cc-compare';

  // Hosts whose /pages/contact counts, besides the current one.
  var STORE_HOSTS = ['valleyridge.ca', 'www.valleyridge.ca'];

  // /pages/contact, with an optional Markets locale prefix (/en-us/...).
  var CONTACT_PATH = /^(\/[a-z]{2}(-[a-z]{2})?)?\/pages\/contact\/?$/i;

  function isContactUrl(link) {
    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch (e) {
      return false;
    }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return false;

    var host = url.host.toLowerCase();
    if (host !== window.location.host.toLowerCase() && STORE_HOSTS.indexOf(host) === -1) return false;

    return CONTACT_PATH.test(url.pathname);
  }

  function isProductCopyContactLink(link) {
    if (!link || !link.hasAttribute('href') || link.hasAttribute('download')) return false;
    if (!link.closest(COPY_SELECTOR) || link.closest(EXCLUDE_SELECTOR)) return false;
    return isContactUrl(link);
  }

  // The modal and its opener, once main.js has upgraded them. Null means the
  // link should just navigate.
  function getModalParts() {
    var modal = document.getElementById('oos__pop-up');
    var button = document.querySelector('modal-opener[data-modal="oos__pop-up"] button#oos-popup-button');
    if (!modal || !button || typeof modal.open !== 'function') return null;
    return { modal: modal, button: button };
  }

  // Tell assistive tech the link opens a dialog. Only set when the modal is
  // on the page, since without it the link navigates.
  function markLinks(root) {
    if (!root || !root.querySelectorAll || !document.getElementById('oos__pop-up')) return;
    root.querySelectorAll('a[href]').forEach(function (link) {
      if (isProductCopyContactLink(link)) link.setAttribute('aria-haspopup', 'dialog');
    });
  }

  document.addEventListener('click', function (evt) {
    if (evt.defaultPrevented || evt.button !== 0) return;
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

    var link = evt.target.closest ? evt.target.closest('a[href]') : null;
    if (!isProductCopyContactLink(link)) return;

    var parts = getModalParts();
    if (!parts) return;

    evt.preventDefault();
    // modal-opener opens the modal with the hidden button as its opener; the
    // button's own listener lazy-loads the Globo form and fills in the variant.
    parts.button.click();
    // Return focus to the link on close, not to the hidden button.
    parts.modal.openedBy = link;
    // Enterprise focuses <modal-dialog> itself, which is not focusable, so
    // focus would stay on the link and Escape (listened for on the modal)
    // would not close it. Move focus into the dialog window instead.
    var dialogWindow = parts.modal.querySelector('[role="dialog"]');
    if (dialogWindow) dialogWindow.focus({ preventScroll: true });
  });

  // The variant picker swaps whole regions (the description tab is one) on
  // variant or product change; mark links in the incoming markup.
  document.addEventListener('on:variant:before-replace-element', function (evt) {
    if (evt.detail) markLinks(evt.detail.replaceWith);
  });

  function init() {
    markLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.VrfProductCopyContactLinks = { isProductCopyContactLink: isProductCopyContactLink };
})();
